import { Messages } from '../../../codegen/Localize';
import { RemoteRefreshTypes } from '../../serverApi/requests/GetRemoteRefreshSchedulesRequest';

export interface IRemoteRefreshScheduleTypeNameFilter {
  (remoteRefreshType: string): string;
}

function remoteRefreshTypeName(remoteRefreshType: keyof typeof RemoteRefreshTypes) {
  switch(remoteRefreshType) {
    case RemoteRefreshTypes.Full:
      return Messages.remoteRefreshScheduleTypeNameFull();
    case RemoteRefreshTypes.Incremental:
      return Messages.remoteRefreshScheduleTypeNameIncremental();
    default:
      return '';
  }
}

export const RemoteRefreshTypeNameFilter: IRemoteRefreshScheduleTypeNameFilter = remoteRefreshTypeName;